<template>
  <div id="footer" class="container">
    <v-row justify="center">
      <v-col cols="10" class="ref">
        <!--
        <img :src="$config.graphpath + 'Logoleiste_InnovationHub13_Webseite.png'" alt="" title="" />        
        -->
      </v-col>    
    </v-row>
    <v-layout class="iblue">
      <v-container>
        <v-row align="center">                    
          <v-col class="wrap" cols="12" xl="10" md="11" lg="11" sm="12" offset-xl="1">
            <Contact></Contact>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
  </div>

</template>

<script>

import Contact from './Contact';

  export default {
    data () {
      return {
      }
    },
    props: {

    },    
    components: {
      Contact
    },    
    methods:{

    },
    mounted() {
        //console.log("Mounted contacts module");
        //console.log(this.contacts);            
    } 
  }
</script>

<style>

</style>
